import { toast } from 'sonner'

export async function copyToClipboard(
  text: string,
  successMsg?: string,
): Promise<void> {
  await navigator.clipboard.writeText(text)
  if (successMsg) toast.success(successMsg, { description: text })
}

export async function copySecretToClipboard(
  text: string,
  successMsg: string,
): Promise<void> {
  await navigator.clipboard.writeText(text)
  toast.success(successMsg)
}

// This function is used to copy text that's generated asynchronously to the clipboard
// because some browsers (Safari) don't support copying text that's generated asynchronously
// in a direct way.
//
// Returns true if the copy succeeded, false otherwise.
export async function copyPromiseToClipboard(
  textPromise: Promise<string | null>,
): Promise<boolean> {
  try {
    const dataToCopy = textPromise.then((text) => {
      if (!text) {
        throw new Error('No data to copy')
      }
      return new Blob([text], { type: 'text/plain' })
    })

    const item = new ClipboardItem({
      'text/plain': dataToCopy,
    })

    await navigator.clipboard.write([item])
    return true
  } catch {
    return false
  }
}
